/** biome-ignore-all lint/complexity/noExcessiveLinesPerFunction: TODO: migrate to react-query */
import { Trans } from 'react-i18next';
import { minBy, orderBy } from 'es-toolkit';
import { saveAs } from 'file-saver';
import i18n from 'i18next';
import moment from 'moment';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { getLocalDateTime } from '@/utils/date';
import { generateUUIDv4 } from '@/utils/number';
import { convertEmptyStringToUndefinedFromObject } from '@/utils/object';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { shipmentAddressBookListApiToLocal } from '@/views/screens/AddressBook/data-provider/search/normalize';
import { getShipmentDashboardAPI } from '@/views/screens/Shipment/data-provider/shipment-dashboard/api';

import { PARCEL_EXPRESS_CHART_TYPES, PARCEL_EXPRESS_CHART_TYPES_API } from '../../contants/common';
import { DEFAULT_SHIPMENT_TABLE_VIEW_COLUMNS } from '../../contants/ShipmentEnums';
import { convertMilesToKm, getErrorMessageFromAPI, trimObjectValues, valueToNumber } from '../../utilz';
import { getDateLabel } from '../../utilz/dates';
import {
  convertRateEngineApiResponseToShipmentLocal,
  convertRateShopResponseToAPI,
  convertShipmentApiResponseToLocal,
  convertShipmentRackingLocalToAPI,
  shipmentSpotBidDataToLocal,
  shipmentTrackApiToLocal,
} from '../../utilz/shipmentDataManupulation';
import { QUOTE_STATUSES } from '../../views/screens/Shipment/components/QuoteCard/constants';
import {
  setAppLoader,
  setFilterToggle,
  setPageBlocker,
  setShipmentModal,
  setWarningModal,
} from '../common/CommonActions';
import { getSpotQuote } from '../common/CommonEffects';
import {
  addShipmentRateEntryInError,
  addShipmentRateEntryInSuccess,
  addSpotQuoteBiddersError,
  addSpotQuoteCollaboratorsError,
  awardSpotQuoteBiddersError,
  awardSpotQuoteBiddersSuccess,
  consolidateShipmentsInError,
  consolidateShipmentsInSuccess,
  convertPartialToShipmentInError,
  convertPartialToShipmentInSuccess,
  copyShipmentInError,
  copyShipmentInSuccess,
  createChildShipmentInError,
  createChildShipmentInSuccess,
  createParcelExpressShippingLabelInError,
  createParcelExpressShippingLabelInSuccess,
  createShipmentFromQuoteInError,
  createShipmentFromQuoteInSuccess,
  createShipmentInError,
  createShipmentInSuccess,
  createShipmentQuoteInError,
  createShipmentQuoteInSuccess,
  deleteNotificationDistributionsInError,
  deleteNotificationDistributionsInSuccess,
  deleteNotificationRoutingInError,
  deleteNotificationRoutingInSuccess,
  deleteShipmentAddressBookInError,
  deleteShipmentAddressBookInSuccess,
  deleteShipmentTenderProcessInError,
  deleteShipmentTenderProcessInSuccess,
  deleteSpotQuoteBiddersError,
  deleteSpotQuoteCollaboratorsError,
  generateApprovalNumberInError,
  generateApprovalNumberInSuccess,
  generateShipmentNoInError,
  generateShipmentNoInSuccess,
  getCargoSpecificShipmentAccessorialsInError,
  getCargoSpecificShipmentAccessorialsInSuccess,
  getCustomerRoutingSettingsInError,
  getCustomerRoutingSettingsInSuccess,
  getMasterChildShipmentDetailsInError,
  getMasterChildShipmentDetailsInSuccess,
  getMilageByStopsInError,
  getMilageByStopsInSuccess,
  getParcelExpressDashboardDataInError,
  getParcelExpressDashboardDataInSuccess,
  getParcelExpressRatesInError,
  getParcelExpressRatesInSuccess,
  getSearchQuoteListInSuccess,
  getShipmentAdvancedPlanningNoticeEmailsInError,
  getShipmentAdvancedPlanningNoticeEmailsInSuccess,
  getShipmentBranchAddressInError,
  getShipmentBranchAddressInSuccess,
  getShipmentCustomerAccessorialsInError,
  getShipmentCustomerAccessorialsInSuccess,
  getShipmentDashboardInError,
  getShipmentDashboardInSuccess,
  getShipmentDefaultAccessorialsInError,
  getShipmentDefaultAccessorialsInSuccess,
  getShipmentDetailsInError,
  getShipmentDetailsInProgress,
  getShipmentDetailsInSuccess,
  getShipmentDocumentsListInError,
  getShipmentDocumentsListInSuccess,
  getShipmentListInError,
  getShipmentListInProgress,
  getShipmentListInSuccess,
  getShipmentNotificationDistributionsInError,
  getShipmentNotificationDistributionsInSuccess,
  getShipmentNotificationRoutingInError,
  getShipmentNotificationRoutingInSuccess,
  getShipmentProductFullListInError,
  getShipmentProductFullListInSuccess,
  getShipmentProductListInError,
  getShipmentProductListInSuccess,
  getShipmentRateShopListInError,
  getShipmentRateShopListInSuccess,
  getShipmentSpotBidDataInError,
  getShipmentSpotBidDataInSuccess,
  getShipmentsStopsInError,
  getShipmentsStopsInSuccess,
  getShipmentTableViewColumnsInError,
  getShipmentTableViewColumnsInSuccess,
  getShipmentTenderEmailInError,
  getShipmentTenderEmailInSuccess,
  getShipmentTrackingDetailsInError,
  getShipmentTrackingDetailsInSuccess,
  getSpotQuoteBiddersError,
  getSpotQuoteBiddersSuccess,
  getSpotQuoteCollaboratorsError,
  getSpotQuoteCollaboratorsSuccess,
  refreshShipmentDetails,
  refreshShipmentListInError,
  refreshShipmentListInProgress,
  refreshShipmentListInSuccess,
  removeShipmentRateEntryInError,
  removeShipmentRateEntryInSuccess,
  saveNotificationDistributionsInError,
  saveNotificationDistributionsInSuccess,
  saveNotificationRoutingInError,
  saveNotificationRoutingInSuccess,
  saveShipmentAccountingPartialInError,
  saveShipmentAccountingPartialInSuccess,
  saveShipmentAddressBookInError,
  saveShipmentAddressBookInSuccess,
  saveShipmentItrackInError,
  saveShipmentItrackInSuccess,
  saveShipmentProductInError,
  saveShipmentProductInSuccess,
  saveShipmentTableViewColumnsInError,
  saveShipmentTableViewColumnsInSuccess,
  searchCustomerAddressBookInError,
  searchCustomerAddressBookInSuccess,
  searchSpotQuoteBiddersError,
  searchSpotQuoteBiddersSuccess,
  sendMailShipmentDocumentInError,
  sendMailShipmentDocumentInSuccess,
  sendShipmentAdvancedPlanningNoticeEmailInError,
  sendShipmentAdvancedPlanningNoticeEmailInSuccess,
  sendShipmentApprovalRequestInError,
  sendShipmentApprovalRequestInSuccess,
  setSelectedShipments,
  setShipmentData,
  setShipmentEditStatus,
  setShipmentList,
  shipmentAddBidderInError,
  shipmentAddBidderInSuccess,
  shipmentAssignCarrierInError,
  shipmentAssignCarrierInSuccess,
  shipmentEndSpotBidInError,
  shipmentEndSpotBidInSuccess,
  shipmentMileageCalculatorInError,
  shipmentMileageCalculatorInSuccess,
  shipmentSpotBidInError,
  shipmentSpotBidInSuccess,
  shipmentTenderProcessInError,
  shipmentTenderProcessInSuccess,
  updateCustomerAddressBook,
  updateShipmentBOLCarrierInError,
  updateShipmentBOLCarrierInSuccess,
  updateShipmentProductFreightClassInError,
  updateShipmentProductFreightClassInSuccess,
  updateShipmentProductListPartialInError,
  updateShipmentRateEntryInError,
  updateShipmentRateEntryInSuccess,
  updateShipmentSingleProductByIndex,
  validateAndGetApproversListInError,
  validateAndGetApproversListInSuccess,
  validateShipmentRateEntryInError,
  validateShipmentRateEntryInSuccess,
} from './ShipmentActions';
import {
  addQuoteBiddersEffect,
  addSpotQuoteBiddersEffect,
  addSpotQuoteCollaboratorsEffect,
  consolidateShipmentsEffect,
  convertPartialToShipmentEffect,
  copyShipmentEffect,
  createChildShipmentEffect,
  createParcelExpressShipmentEffect,
  createPartialShipmentEffect,
  createShipmentEffect,
  createShipmentFromQuoteEffect,
  createShipmentNotificationDistributorsEffect,
  createShipmentNotificationRoutingEffect,
  createShipmentQuoteEffect,
  deleteShipmentAddressBookEffect,
  deleteShipmentNotificationDistributorsEffect,
  deleteShipmentNotificationRoutingEffect,
  deleteShipmentsEffect,
  deleteShipmentTenderProcessEffect,
  deleteSpotQuoteBiddersEffect,
  deleteSpotQuoteCollaboratorsEffect,
  generateApprovalNoEffect,
  generateAutomaticProNumber,
  generateShipmentNoEffect,
  getAPIRateShopByWrapperAPIEffect,
  getCargoSpecificAccessorialsEffect,
  getMasterChildShipmentDetailsEffect,
  getMilageByStopsEffect,
  getParcelExpressDashboardDataEffect,
  getParcelExpressRatesEffect,
  getSearchQuoteListEffect,
  getShipmentAdvancePlanningNoticeEmailsEffect,
  getShipmentBranchAddressEffect,
  getShipmentCustomerAddressBookSearchEffect,
  getShipmentCustomerRoutingsSettingsEffect,
  getShipmentDefaultAccessorialsForCustomerEffect,
  getShipmentDetailsEffect,
  getShipmentDocumentListEffect,
  getShipmentItrackEffect,
  getShipmentListEffect,
  getShipmentNotificationDistributorsEffect,
  getShipmentNotificationRoutingEffect,
  getShipmentProductFullListEffect,
  getShipmentProductListEffect,
  getShipmentRateShopListEffect,
  getShipmentSpotBidDataEffect,
  getShipmentsStopsEffect,
  getShipmentTableViewColumn,
  getShipmentTenderEmailEffect,
  getSpotQuoteBiddersEffect,
  getSpotQuoteCollaboratorsEffect,
  SetSpotQuoteStatusAwardedEffect,
  saveRateShopResultEffect,
  saveShipmentAccessorialsPartialEffect,
  saveShipmentAddressBookEffect,
  saveShipmentItrackEffect,
  saveShipmentProductEffect,
  saveShipmentRateShopFiltersEffect,
  saveShipmentTableViewColumn,
  saveShipmentTaxesPartialEffect,
  searchSpotQuoteBiddersEffect,
  sendMailShipmentDocumentEffect,
  sendShipmentAdvancePlanningNoticeEmailEffect,
  sendShipmentApprovalEffect,
  setSpotQuoteStatusAwardedEffect,
  shipmentAddBidderEffect,
  shipmentAddRateEntryEffect,
  shipmentCalculateMileageEffect,
  shipmentEndSpotBidEffect,
  shipmentPartialSaveEffect,
  shipmentRemoveRateEntryEffect,
  shipmentSpotBidEffect,
  shipmentTenderProcessEffect,
  shipmentUpdateRateEntryEffect,
  shipmentValidateRateEntryEffect,
  updateShipmentBOLCarrierEffect,
  updateShipmentNotificationDistributorsEffect,
  updateShipmentNotificationRoutingEffect,
  updateShipmentProductFBCLassEffect,
  updateShipmentStatusToRatedEffect,
  validateAndGetApproversEffect,
} from './ShipmentEffects';
import ShipmentTypes from './ShipmentTypes';

function* getShipmentList() {
  const {
    shipment: { shipmentFilters },
  } = yield select((state) => state);
  try {
    const { data } = yield call(getShipmentListEffect, shipmentFilters);
    yield put(getShipmentListInSuccess({ data }));
  } catch (e) {
    if (e?.code !== 'ERR_CANCELED') {
      yield put(getShipmentListInError({ message: getErrorMessageFromAPI(e) }));
    }
  }
}

function* getSearchQuoteList() {
  const {
    shipment: { searchQuoteFilters },
  } = yield select((state) => state);
  try {
    const { data } = yield call(getSearchQuoteListEffect, searchQuoteFilters);
    yield put(getSearchQuoteListInSuccess({ data }));
  } catch (e) {
    if (e?.code !== 'ERR_CANCELED') {
      yield put(getShipmentListInError({ message: getErrorMessageFromAPI(e) }));
    }
  }
}

function* refreshShipmentList() {
  const {
    shipment: { shipmentFilters },
  } = yield select((state) => state);
  try {
    const param = {
      CreatedDateFrom: getDateLabel(moment(getLocalDateTime()).subtract(1, 'months')),
      CreatedDateTo: getDateLabel(getLocalDateTime()),
      ...convertEmptyStringToUndefinedFromObject(shipmentFilters),
      PageNumber: 1,
      PageSize: shipmentFilters.PageNumber * shipmentFilters.PageSize,
    };
    const { data } = yield call(getShipmentListEffect, param);
    yield put(refreshShipmentListInSuccess({ data }));
  } catch (e) {
    if (e?.code !== 'ERR_CANCELED') {
      yield put(refreshShipmentListInError({ message: getErrorMessageFromAPI(e) }));
    }
  }
}

function* getShipmentDetails({ payload }) {
  try {
    let { data } = yield call(getShipmentDetailsEffect, payload);
    data = yield convertShipmentApiResponseToLocal(data);
    yield put(
      getShipmentDetailsInSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentDetailsInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetShipment')),
      }),
    );
  }
}

function* getShipmentDashboard({ payload: { fieldType, ...rest } }) {
  try {
    const { data } = yield call(getShipmentDashboardAPI, rest);
    yield put(getShipmentDashboardInSuccess({ data, fieldType }));
  } catch (e) {
    yield put(
      getShipmentDashboardInError({
        fieldType,
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* generateShipmentNo({ payload }) {
  try {
    const { data } = yield call(generateShipmentNoEffect, payload);
    yield put(generateShipmentNoInSuccess({ shipmentNo: data }));
  } catch (e) {
    yield put(
      generateShipmentNoInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* generateApprovalNo({ payload }) {
  try {
    const { data } = yield call(generateApprovalNoEffect, payload);
    yield put(generateApprovalNumberInSuccess({ approvalNo: data }));
  } catch (e) {
    yield put(
      generateApprovalNumberInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* deleteShipments({ payload }) {
  try {
    yield call(deleteShipmentsEffect, payload);

    yield put(setSelectedShipments([]));
    yield put(refreshShipmentListInProgress());
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.shipmentDeletedSuccessfully'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch {
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.failedToDeleteShipments'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  }
}

function* copyShipment({ payload }) {
  const UserId = yield select((state) => state.auth.user.data?.id);
  try {
    payload.UserId = UserId;

    const { data } = yield call(copyShipmentEffect, payload);

    yield put(
      copyShipmentInSuccess({
        data,
      }),
    );
    yield put(setSelectedShipments([]));
    yield put(setAppLoader(false));
    const title = data.approvalNumber
      ? `${i18n.t('translation:default.fields.approvalNo')} ${payload.oldApprovalNumber} ${i18n.t(
          'translation:default.notification.successfullyCopied',
        )} ${i18n.t('translation:default.fields.approvalNo')} ${data.approvalNumber}.`
      : `${i18n.t('translation:default.fields.shipmentNoNumber')} ${
          payload.oldShipmentNumber
        } ${i18n.t('translation:default.fields.shipmentNoCopied')} 
          ${i18n.t('translation:default.notification.successNewCopied')} ${data.shipmentNumber}.`;
    yield call(showNotification, {
      message: title,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(setShipmentList({ data: [], progressing: true }));
    yield put(getShipmentListInProgress());
    yield put(getShipmentDetailsInProgress({ ShipmentKey: data?.shipmentKey }));
    yield put(setShipmentModal(data?.shipmentKey));
    yield put(setFilterToggle(false));
  } catch (e) {
    yield put(
      copyShipmentInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: e?.response?.data
        ? e?.response?.data
        : `${i18n.t('translation:default.fields.failedToCopyShipmentNo')} ${payload.oldShipmentNumber}.`,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* consolidateShipments({ payload: { handleSuccess, shipmentNoList, ...payload } }) {
  try {
    const { data } = yield call(consolidateShipmentsEffect, payload);

    yield put(
      consolidateShipmentsInSuccess({
        data,
      }),
    );
    yield put(setSelectedShipments([]));
    yield put(setAppLoader(false));
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey: payload.CustomerKey,
        ShipmentKey: data.shipmentKey,
      }),
    );
    if (handleSuccess) {
      handleSuccess();
    }
    yield put(setShipmentModal(data.shipmentKey));
    yield call(showNotification, {
      message: `${i18n.t('translation:default.notification.shipmentsFollowing')}${data.shipmentNumber}.`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(setShipmentList({ data: [], progressing: true }));
    yield put(getShipmentListInProgress());
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.shipmentConsolidationFailed'));
    yield put(
      consolidateShipmentsInError({
        message: errorMessage,
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: errorMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* createShipment({ payload: { handleSuccess, isPartialSave, ...payload } }) {
  try {
    let data = {};
    if (!isPartialSave) {
      const { data: dataLocal } = yield call(createShipmentEffect, payload);
      data = dataLocal;
    } else {
      const { data: dataLocal } = yield call(createPartialShipmentEffect, payload);
      data = dataLocal;
    }

    if (data === 0) {
      throw i18n.t('translation:default.notification.errorWithCode0');
    }

    if (handleSuccess) {
      yield put(setShipmentModal(data?.shipmentKey || data));
      const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
        ShipmentKey: data?.shipmentKey || data,
      });

      yield put(
        getShipmentDetailsInSuccess({
          data: convertShipmentApiResponseToLocal(shipmentDetailsData),
        }),
      );
      handleSuccess(shipmentDetailsData);
    }

    yield put(
      createShipmentInSuccess({
        data,
      }),
    );

    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.shipmentCreatedSuccessfully'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(setPageBlocker(false));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e)
      ? getErrorMessageFromAPI(e)
      : i18n.t('translation:default.fields.shipmentCreationFailed');
    yield put(
      createShipmentInError({
        message: errorMsg,
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* shipmentSpotBid({ payload: { callBackFun, ...payload } }) {
  try {
    const { data } = yield call(shipmentSpotBidEffect, payload);

    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
    if (data != 1) {
      throw i18n.t('translation:default.notification.errorWithCode0');
    }

    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      CustomerKey: payload.customerKey,
      ShipmentKey: payload.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );

    yield call(showNotification, {
      message: i18n.t('translation:default.fields.shipmentSend'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });

    if (callBackFun) {
      callBackFun();
    }

    yield put(
      shipmentSpotBidInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    yield put(refreshShipmentListInProgress());
  } catch (e) {
    yield put(
      shipmentSpotBidInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.shipmentSendFailed'),
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* shipmentAddBidder({ payload: { callBackFun, ...payload } }) {
  try {
    const { data } = yield call(shipmentAddBidderEffect, payload);

    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
    if (data != 1) {
      throw i18n.t('translation:default.notification.errorWithCode0');
    }

    yield call(showNotification, {
      message: <Trans i18nKey="translation:default.fields.bidderAddedSuccessfully" />,
      type: NOTIFICATION_TYPES.SUCCESS,
    });

    if (callBackFun) {
      callBackFun();
    }

    yield put(
      shipmentAddBidderInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      shipmentAddBidderInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.failedToAddBidder'),
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getShipmentRateShopList({
  payload: { havingLeastCost, isNeedToSave = false, isAPIRateShop = false, handleDone = false, ...payload },
}) {
  const {
    auth: { user },
    shipment: { shipmentDetails },
  } = yield select((state) => state);
  try {
    let rateShopResults = {};
    if (isAPIRateShop) {
      let { data } = yield call(getAPIRateShopByWrapperAPIEffect, payload);

      if (Array.isArray(data?.nVision_Response)) {
        data = data.nVision_Response;
      } else {
        // biome-ignore lint/style/noMagicNumbers: not a magic number
        data = data?.httpResponse?.CarrierResponses?.filter(({ StatusCode }) => StatusCode === 200);
        data = data.map(({ nVision_Response }) => nVision_Response);
      }
      if (data?.length === 0) {
        throw { customMessage: 'No rates are available', skipReset: true };
      }
      rateShopResults = data;
    } else {
      const { data } = yield call(getShipmentRateShopListEffect, payload);
      rateShopResults = data;
    }

    if (havingLeastCost) {
      rateShopResults = yield rateShopResults?.filter((row) => (row.totalShipmentCost ?? row.TotalShipmentCost) > 0);
      rateShopResults = yield minBy(rateShopResults, (row) =>
        valueToNumber(row.totalShipmentCost ?? row.TotalShipmentCost),
      );
    }
    rateShopResults = yield call(convertRateEngineApiResponseToShipmentLocal, rateShopResults, isAPIRateShop);
    rateShopResults = rateShopResults.map((row) => ({
      ...row,
      userCreatedBy: user.data.email,
    }));

    // To handle previous data expect API Rate Shop data.
    if (isAPIRateShop) {
      const nonAPIRateShopDataOld = (
        shipmentDetails?.data?.rateShopList ? shipmentDetails?.data?.rateShopList : []
      )?.filter(({ pricingBasis }) => pricingBasis !== 'API' && pricingBasis !== 'SPOT');
      rateShopResults = [...rateShopResults, ...nonAPIRateShopDataOld];
    } else {
      const APIRateShopDataOld = (
        shipmentDetails?.data?.rateShopList ? shipmentDetails?.data?.rateShopList : []
      )?.filter(({ pricingBasis }) => pricingBasis === 'API');
      rateShopResults = [...rateShopResults, ...APIRateShopDataOld];
    }

    if (isNeedToSave) {
      const saveRateShopPayload = {
        branchkey: shipmentDetails?.data?.branchKey,
        createdBy: user?.data?.id,
        customerKey: shipmentDetails?.data?.customerKey,
        shipmentKey: shipmentDetails?.data?.shipmentKey,
      };
      const spotData = [];
      saveRateShopPayload.listRateShopDataAPI = convertRateShopResponseToAPI(
        [...rateShopResults, ...spotData],
        shipmentDetails?.data?.customerKey,
      );

      const { data: ratesList } = yield call(saveRateShopResultEffect, saveRateShopPayload);

      yield put(
        getShipmentRateShopListInSuccess({
          data: ratesList
            ? ratesList?.map((row) => ({
                ...row,
                accessorials: row.freightAccessorialCollection
                  ? row.freightAccessorialCollection?.map((row) => ({
                      ...row,
                      auditedChargeAmount: row.cost,
                      currencyCode: row.currency,
                      description: row.costName,
                    }))
                  : [],
              }))
            : [],
          forceUpdate: true,
          replaceShipment: true,
        }),
      );
    } else {
      yield put(
        getShipmentRateShopListInSuccess({
          data: rateShopResults,
          forceUpdate: true,
        }),
      );
    }
    if (handleDone) {
      handleDone();
    }
  } catch (e) {
    console.log(e);
    const message = e.customMessage
      ? e.customMessage
      : getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToLoadRate'));
    yield put(
      getShipmentRateShopListInError({
        message,
        skipReset: Boolean(e.skipReset),
      }),
    );
    yield call(showNotification, {
      message,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* shipmentEndSpotBid({ payload: { callBackFun, customerKey, ...payload } }) {
  try {
    const { data } = yield call(shipmentEndSpotBidEffect, payload);
    // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
    if (data != 1) {
      throw i18n.t('translation:default.notification.errorWithCode0');
    }

    yield put(
      shipmentEndSpotBidInSuccess({
        data,
      }),
    );

    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      CustomerKey: customerKey,
      ShipmentKey: payload.ShipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );

    yield put(setAppLoader(false));

    yield call(showNotification, {
      message: <Trans i18nKey="translation:default.fields.yourSpotBidHasEnded" />,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    if (callBackFun) {
      callBackFun();
    }
  } catch (e) {
    yield put(
      shipmentEndSpotBidInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: <Trans i18nKey="translation:default.fields.failedYourSpotBid" />,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getShipmentDocumentsList({ payload }) {
  try {
    const { data } = yield call(getShipmentDocumentListEffect, payload);

    yield put(getShipmentDocumentsListInSuccess({ data }));
  } catch (e) {
    yield put(
      getShipmentDocumentsListInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getShipmentDefaultAccessorials({ payload }) {
  try {
    const { data } = yield call(getShipmentDefaultAccessorialsForCustomerEffect, payload);

    yield put(getShipmentDefaultAccessorialsInSuccess({ data }));
  } catch (e) {
    yield put(
      getShipmentDefaultAccessorialsInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getShipmentTenderEmail({ payload }) {
  try {
    const { data } = yield call(getShipmentTenderEmailEffect, payload);

    yield put(getShipmentTenderEmailInSuccess({ data }));
  } catch (e) {
    yield put(
      getShipmentTenderEmailInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* shipmentTenderProcess({ payload: { shipmentStatusUpdateData, ...payload } }) {
  const shipmentDetails = yield select((state) => state.shipment.shipmentDetails);
  try {
    const selectedRateDetails = shipmentDetails?.data?.rateShopList?.find(
      ({ rateShopKey }) => rateShopKey === shipmentDetails.data?.rateShopKey,
    );
    payload.ISAPIPickup = selectedRateDetails?.pricingBasis === 'API';
    const { data } = yield call(shipmentTenderProcessEffect, payload);

    const { data: shipmentData } = yield call(getShipmentDetailsEffect, {
      CustomerKey: payload.customerKey,
      ShipmentKey: payload.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentData),
      }),
    );
    yield put(shipmentTenderProcessInSuccess({ data }));
    let message = i18n.t('translation:default.fields.shipmentTenderProcessSuccess');
    if (data?.carrierResponse?.referenceNumber) {
      message = `Pickup API Response: Pickup created successfully! Thank you!. Reference No- ${data.carrierResponse.referenceNumber}`;
    }
    yield call(showNotification, {
      message,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(refreshShipmentListInProgress());
  } catch (e) {
    const errorMessage = e?.response?.data?.carrierResponse?.carrierStatus
      ? e?.response?.data?.carrierResponse?.carrierStatus
      : getErrorMessageFromAPI(e, i18n.t('translation:default.fields.shipmentTenderProcessError'));
    yield put(
      shipmentTenderProcessInError({
        message: errorMessage,
      }),
    );
    yield call(showNotification, {
      message: errorMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getSpotBidData({ payload }) {
  try {
    const { data } = yield call(getShipmentSpotBidDataEffect, payload);

    yield put(
      getShipmentSpotBidDataInSuccess({
        data: shipmentSpotBidDataToLocal(data),
      }),
    );
  } catch (e) {
    yield put(
      getShipmentSpotBidDataInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* shipmentPartialSave({ payload: { notificationTitle, callBack, handleError, refetchShipment, ...payload } }) {
  try {
    const { data } = yield call(shipmentPartialSaveEffect, payload);
    yield put(setShipmentEditStatus(false));

    if (refetchShipment) {
      const { data } = yield call(getShipmentDetailsEffect, {
        CustomerKey: refetchShipment.customerKey,
        ShipmentKey: refetchShipment.shipmentKey,
      });
      yield put(
        getShipmentDetailsInSuccess({
          data: convertShipmentApiResponseToLocal(data),
          skipRateShop: true,
        }),
      );
    }
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: `${notificationTitle}.`,
      toastId: '0',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    if (callBack) {
      callBack(data);
    }
  } catch (e) {
    if (handleError) {
      handleError(e);
    }
    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || `${notificationTitle}.`,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* shipmentMileageCalculator({ payload: { callBack, ...payload } }) {
  try {
    const { data } = yield call(shipmentCalculateMileageEffect, payload);
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyCalculated'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });

    if (callBack) {
      callBack(data);
    }
    yield put(shipmentMileageCalculatorInSuccess({ data }));
  } catch (e) {
    yield put(shipmentMileageCalculatorInError({ data: [] }));

    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || i18n.t('translation:default.fields.failedToCalculateTheMileage'),
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* getCustomerRoutingsSettings({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getShipmentCustomerRoutingsSettingsEffect, payload);
    yield put(
      getCustomerRoutingSettingsInSuccess({
        data: data?.[0] ? data?.[0] : {},
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      getCustomerRoutingSettingsInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* saveAddressBook({ payload: { callback, ...payload } }) {
  try {
    const { data } = yield call(saveShipmentAddressBookEffect, payload);
    yield put(
      saveShipmentAddressBookInSuccess({
        data,
      }),
    );
    yield put(
      updateCustomerAddressBook({
        data: {
          ...shipmentAddressBookListApiToLocal([payload])[0],
          ...(data?.searchId ? { searchId: data?.searchId } : {}),
          ...(data?.locationId ? { locationId: data?.locationId } : {}),
        },
      }),
    );
    if (callback) {
      callback({
        ...payload,
        ...(data?.searchId ? { searchId: data?.searchId } : {}),
        ...(data?.locationId ? { locationId: data?.locationId } : {}),
      });
    }
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySavedAddressBook'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || i18n.t('translation:default.fields.failedToSaveAddressBook'),
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      saveShipmentAddressBookInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSaveAddressBook')),
      }),
    );
  }
}

function* deleteAddressBook({ payload: { callBackSuccess, ...payload } }) {
  try {
    const { data } = yield call(deleteShipmentAddressBookEffect, payload);
    yield put(
      deleteShipmentAddressBookInSuccess({
        data,
      }),
    );
    if (callBackSuccess) {
      callBackSuccess(payload);
    }
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyDeletedAddressBook'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || i18n.t('translation:default.fields.failedToDeleteAddressBook'),
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      deleteShipmentAddressBookInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToDeleteAddressBook')),
      }),
    );
  }
}

function* saveProduct({ payload: { callback, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(saveShipmentProductEffect, payload);
    yield put(
      saveShipmentProductInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    if (callback) {
      callback(payload);
    }
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySavedProduct'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    yield put(setAppLoader(false));
    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || i18n.t('translation:default.fields.failedToSaveProduct'),
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      saveShipmentProductInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSaveProduct')),
      }),
    );
  }
}

function* getTrackingDetails({ payload }) {
  try {
    const { data } = yield call(getShipmentItrackEffect, payload);
    yield put(
      getShipmentTrackingDetailsInSuccess({
        data: shipmentTrackApiToLocal(data),
      }),
    );
  } catch (e) {
    console.log(e);
    yield put(
      getShipmentTrackingDetailsInError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* sendDocumentMail({ payload }) {
  try {
    const { data: responseData } = yield call(sendMailShipmentDocumentEffect, payload);
    yield put(
      sendMailShipmentDocumentInSuccess({
        data: responseData,
      }),
    );
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.documentEmailsSuccessfullySent'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSendDocumentEmail'));
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      sendMailShipmentDocumentInError({
        message: errMsg,
      }),
    );
  }
}

function* saveShipmentItrack({ payload: { reFetchData, ...payload } }) {
  try {
    const { data: responseData } = yield call(saveShipmentItrackEffect, convertShipmentRackingLocalToAPI(payload));
    yield put(
      saveShipmentItrackInSuccess({
        data: responseData,
      }),
    );

    if (reFetchData) {
      const { data } = yield call(getShipmentItrackEffect, reFetchData);
      yield put(
        getShipmentTrackingDetailsInSuccess({
          data: shipmentTrackApiToLocal(data),
        }),
      );
    }
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySavedITrackDetails'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSaveITrackDetails'));
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      saveShipmentItrackInError({
        message: errMsg,
      }),
    );
  }
}

function* getShipmentNotificationRoutingAction({ payload }) {
  try {
    const { data } = yield call(getShipmentNotificationRoutingEffect, payload);
    const normalizedData = data?.map((item) => ({ ...item, lspStationCode: item.lspStationCode || null }));
    yield put(
      getShipmentNotificationRoutingInSuccess({
        data: normalizedData,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentNotificationRoutingInError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getShipmentNotificationDistributorsAction({ payload }) {
  try {
    const { data } = yield call(getShipmentNotificationDistributorsEffect, payload);
    yield put(
      getShipmentNotificationDistributionsInSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentNotificationDistributionsInError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* saveNotificationDistributorsAction({ payload: { callBackSuccess, index, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    if (payload?.distributionId === 0) {
      yield call(createShipmentNotificationDistributorsEffect, [payload]);
    } else {
      yield call(updateShipmentNotificationDistributorsEffect, [payload]);
    }

    if (callBackSuccess) {
      callBackSuccess(index);
    }

    const { data } = yield call(getShipmentNotificationDistributorsEffect, {
      CustomerKey: payload?.customerKey,
    });
    yield put(
      getShipmentNotificationDistributionsInSuccess({
        data,
      }),
    );

    yield put(setAppLoader(false));
    yield put(
      saveNotificationDistributionsInSuccess({
        data: {},
      }),
    );
    yield call(showNotification, {
      message: `${i18n.t('translation:default.notification.successfully')} ${
        payload?.distributionId === 0
          ? i18n.t('translation:default.notification.created')
          : i18n.t('translation:default.notification.updated')
      } ${i18n.t('translation:default.notification.distributorDetails')}.`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(
      e,
      `${i18n.t('translation:default.notification.failedTo')} ${
        payload?.distributionId === 0
          ? i18n.t('translation:default.notification.created')
          : i18n.t('translation:default.notification.updated')
      } ${i18n.t('translation:default.notification.distributorDetails')}.`,
    );
    yield put(setAppLoader(false));
    yield put(
      saveNotificationDistributionsInError({
        message: errMsg,
      }),
    );
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* deleteNotificationDistributorsAction({ payload: { callBackSuccess, items } }) {
  try {
    yield put(setAppLoader(true));
    yield call(deleteShipmentNotificationDistributorsEffect, items);

    if (callBackSuccess) {
      callBackSuccess(items);
    }

    yield put(setAppLoader(false));
    yield put(
      deleteNotificationDistributionsInSuccess({
        data: {},
      }),
    );
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyDeletedDistributorDetails'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToDeleteDistributorDetails'));
    yield put(setAppLoader(false));
    yield put(
      deleteNotificationDistributionsInError({
        message: errMsg,
      }),
    );
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* saveNotificationRouting({ payload: { onSuccess, index, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    if (payload?.routingDetailId === 0) {
      yield call(createShipmentNotificationRoutingEffect, [payload]);
    } else {
      yield call(updateShipmentNotificationRoutingEffect, [payload]);
    }

    if (onSuccess) {
      onSuccess();
    }

    const { data } = yield call(getShipmentNotificationRoutingEffect, {
      CustomerKey: payload?.customerKey,
    });
    yield put(
      getShipmentNotificationRoutingInSuccess({
        data,
      }),
    );

    yield put(setAppLoader(false));
    yield put(
      saveNotificationRoutingInSuccess({
        data: {},
      }),
    );
    yield call(showNotification, {
      message: `${i18n.t('translation:default.notification.successfully')} ${
        payload?.routingDetailId === 0
          ? i18n.t('translation:default.notification.created')
          : i18n.t('translation:default.notification.updated')
      } ${i18n.t('translation:default.notification.routingDetails')}.`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(
      e,
      `${i18n.t('translation:default.notification.failedTo')} ${
        payload?.routingDetailId === 0
          ? i18n.t('translation:default.notification.created')
          : i18n.t('translation:default.notification.updated')
      } ${i18n.t('translation:default.notification.routingDetails')}.`,
    );
    yield put(setAppLoader(false));
    yield put(
      saveNotificationRoutingInError({
        message: errMsg,
      }),
    );
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* deleteNotificationRouting({ payload: { callBackSuccess, items } }) {
  try {
    yield put(setAppLoader(true));
    yield call(deleteShipmentNotificationRoutingEffect, items);

    if (callBackSuccess) {
      callBackSuccess(items);
    }

    yield put(setAppLoader(false));
    yield put(
      deleteNotificationRoutingInSuccess({
        data: {},
      }),
    );
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyDeletedRoutingDetails'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToDeleteRoutingDetails'));
    yield put(setAppLoader(false));
    yield put(
      deleteNotificationRoutingInError({
        message: errMsg,
      }),
    );
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getShipmentCustomerAddressSearch() {
  try {
    const { addressBookFilters } = yield select((state) => state.shipment);
    const { data } = yield call(getShipmentCustomerAddressBookSearchEffect, addressBookFilters);
    yield put(
      searchCustomerAddressBookInSuccess({
        data: shipmentAddressBookListApiToLocal(data?.addressbookResult),
        totalRecords: data?.count,
      }),
    );
  } catch (e) {
    const message = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.currentlyNotAbleToGet'));
    yield put(
      searchCustomerAddressBookInError({
        message,
      }),
    );
  }
}

function* getShipmentCustomerAccessorials({ payload }) {
  try {
    const { data } = yield call(getShipmentDefaultAccessorialsForCustomerEffect, payload);
    yield put(
      getShipmentCustomerAccessorialsInSuccess({
        data: orderBy(data, ['isChecked'], ['desc']).map((row) =>
          trimObjectValues({
            ...row,
            codeId: row?.accChargeType,
            isChecked: Boolean(row?.isChecked),
          }),
        ),
      }),
    );
  } catch (e) {
    yield put(
      getShipmentCustomerAccessorialsInError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* createShipmentQuote({ payload: { formData, handleSuccessCallBack = false } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(createShipmentQuoteEffect, formData);
    yield put(
      createShipmentQuoteInSuccess({
        data,
      }),
    );
    yield put(setPageBlocker(false));
    const { data: shipmentData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: data?.shipmentKey,
    });
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySavedTheQuoted', {
        quoteNo: shipmentData.quoteNo,
      }),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentData),
      }),
    );
    yield put(setShipmentModal(data?.shipmentKey));
    if (handleSuccessCallBack) {
      handleSuccessCallBack();
    }
    yield put(setAppLoader(false));
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(
      e,
      i18n.t('translation:default.fields.failedSaveTheQuoteShipmentDetails'),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      createShipmentQuoteInError({
        message: errMessage,
      }),
    );
  }
}

function* saveShipmentAccountingPartial({
  payload: {
    accessorialsFormData = false,
    taxesFormData = false,
    filterFormData = false,
    handleSuccessCallback = false,
  },
}) {
  try {
    const requests = [];
    if (accessorialsFormData) {
      requests.push(call(saveShipmentAccessorialsPartialEffect, accessorialsFormData));
    }
    if (taxesFormData) {
      requests.push(call(saveShipmentTaxesPartialEffect, taxesFormData));
    }
    if (filterFormData) {
      requests.push(call(saveShipmentRateShopFiltersEffect, filterFormData));
    }
    if (!accessorialsFormData && !taxesFormData) {
      throw i18n.t('translation:default.fields.theUpdatingDataAreInvalid');
    }
    yield all(requests);
    yield put(
      saveShipmentAccountingPartialInSuccess({
        data: {},
        message: `${i18n.t('translation:default.fields.successfullyUpdatedTheAccountingDetails')}.`,
      }),
    );

    if (handleSuccessCallback) {
      yield call(handleSuccessCallback);
    }
  } catch (e) {
    console.log(e);
    const errMessage = getErrorMessageFromAPI(
      e,
      `${i18n.t('translation:default.fields.failedToSaveAccountingDetails')}!`,
    );
    yield put(
      saveShipmentAccountingPartialInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* createShipmentFromQuote({ payload }) {
  const CustomerKey = yield select((state) => state.auth.selectedCompany.companyId);
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(createShipmentFromQuoteEffect, payload);
    yield put(
      createShipmentFromQuoteInSuccess({
        data,
      }),
    );
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey,
        ShipmentKey: data?.shipmentKey,
      }),
    );

    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: `${i18n.t('translation:default.fields.shipmentHasBeenCreatedSuccessfullyWith')} ${data?.shipmentNumber}`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedCreateShipment'));
    yield put(
      createShipmentFromQuoteInError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* getMilageByStops({ payload }) {
  const customerKey = yield select((state) => state.auth?.selectedCompany?.companyId);
  try {
    const { data } = yield call(getMilageByStopsEffect, {
      ...payload,
      CarrierKey: -1,
      CustomerKey: customerKey,
      RoutingOptionKey: 0,
    });
    const totalMilage = data?.Stops[data?.Stops?.length - 1]?.TotalMiles;
    yield put(
      getMilageByStopsInSuccess({
        totalMilageInKm: convertMilesToKm(totalMilage ? totalMilage : 0),
        totalMilageInMiles: totalMilage,
      }),
    );
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetMilageDetails'));
    yield put(
      getMilageByStopsInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getParcelExpressRates({ payload: { handleDone, ...payload } }) {
  try {
    const { data } = yield call(getParcelExpressRatesEffect, payload);
    yield put(
      getParcelExpressRatesInSuccess({
        data,
      }),
    );
    if (handleDone) {
      handleDone(data);
    }
  } catch (e) {
    yield put(
      getParcelExpressRatesInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetRatesData')),
      }),
    );
  }
}

function* validateAndGetApprovers({ payload: { handleSuccess } }) {
  const {
    auth: { user },
    shipment: { shipmentDetails },
  } = yield select((state) => state);
  try {
    yield put(setAppLoader(true));
    const payload = {};
    payload.ShipmentKey = shipmentDetails?.data?.shipmentKey;
    payload.RequestedByUserId = user?.data?.id;
    const { data } = yield call(validateAndGetApproversEffect, payload);
    if (!data?.approvalList || data?.approvalList?.length === 0) {
      yield put(
        refreshShipmentDetails({
          shipmentKey: shipmentDetails?.data?.shipmentKey,
        }),
      );
      throw { custom: true, message: data?.message };
    }

    data.approvalList = data.approvalList.map((approver) => ({
      ...approver,
      selected: Boolean(approver.isChecked),
      selectedPriority: approver.approvalPriority,
    }));

    yield put(
      validateAndGetApproversListInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    if (handleSuccess) {
      handleSuccess();
    }
  } catch (error) {
    yield put(setAppLoader(false));
    yield put(
      validateAndGetApproversListInError({
        message: getErrorMessageFromAPI(error, i18n.t('translation:default.fields.failedToValidateApproval')),
      }),
    );
    // biome-ignore lint/style/useBlockStatements: TODO: fix
    if (!error?.custom)
      yield call(showNotification, {
        message: getErrorMessageFromAPI(error, i18n.t('translation:default.fields.failedToGetApproversList')),
        type: NOTIFICATION_TYPES.ERROR,
      });

    if (error?.custom) {
      yield put(
        setWarningModal({
          description: error?.message ? error?.message : i18n.t('translation:default.fields.somethingWentWrong'),
          open: true,
        }),
      );
    }
  }
}

function* createParcelExpressShipment({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(createParcelExpressShipmentEffect, payload);
    for (let i = 0; i < data?.fileURL?.length; i++) {
      yield saveAs(data.fileURL[i]);
    }
    yield put(
      createParcelExpressShippingLabelInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    const errMsg = data?.error;
    if (errMsg) {
      yield call(showNotification, {
        message: errMsg,
        type: NOTIFICATION_TYPES.ERROR,
      });
    } else {
      let pickupConfirmationCodeMessage = '';
      if (data.pickUpConfimataionCode) {
        pickupConfirmationCodeMessage = ` Pickup confirmation code: ${data.pickUpConfimataionCode}`;
      }
      yield call(showNotification, {
        message: `${i18n.t(
          'translation:default.fields.shippingLabelHasBeenCreatedSuccessfully',
        )} ${data?.shipmentNumber}.${pickupConfirmationCodeMessage}`,
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    }
  } catch (e) {
    yield put(setAppLoader(false));
    const errMsg = e?.response?.data?.errorMessage || e?.response?.data?.message;
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      createParcelExpressShippingLabelInError({
        message: errMsg,
      }),
    );
  }
}

function* createChildShipment({ payload }) {
  try {
    const { data } = yield call(createChildShipmentEffect, payload);
    yield put(
      createChildShipmentInSuccess({
        data,
      }),
    );
    yield call(showNotification, {
      message: `${i18n.t('translation:default.fields.newChildShipmentIsCreated')}${data?.approvalNumber}`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(
      getShipmentDetailsInProgress({
        ShipmentKey: data.shipmentKey,
      }),
    );
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetRatesData'));
    yield call(showNotification, {
      message: errorMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      createChildShipmentInError({
        message: errorMessage,
      }),
    );
  }
}

function* saveShipmentDetails({ payload }) {
  try {
    const { data } = yield call(SetSpotQuoteStatusAwardedEffect, payload);
    yield put(
      awardSpotQuoteBiddersSuccess({
        data,
      }),
    );
    yield call(showNotification, {
      message: `${data}`,
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errorMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(
      awardSpotQuoteBiddersError({
        message: errorMessage,
      }),
    );
  }
}

function* sendApprovalRequest({ payload: { handleSuccess, approversList, isFlagApprovalNeeded } }) {
  const {
    shipment: { shipmentDetails },
    auth: { user },
  } = yield select((state) => state);
  try {
    yield put(setAppLoader(true));
    const requestData = {
      isFlagApprovalNeeded,
      listApprovers: approversList,
      requestedByUserId: user?.data?.id,
      shipmentKey: shipmentDetails?.data?.shipmentKey,
    };
    const { data } = yield call(sendShipmentApprovalEffect, requestData);
    yield put(
      sendShipmentApprovalRequestInSuccess({
        data,
      }),
    );
    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: shipmentDetails?.data?.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySentTheApprovalRequestToTheCustomers'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    if (handleSuccess) {
      handleSuccess();
    }
  } catch (e) {
    yield put(
      sendShipmentApprovalRequestInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetRatesData')),
      }),
    );
    yield call(showNotification, {
      message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSendTheApprovalRequest')),
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* assignCarrierToShipment({
  payload: { handleSuccess, preAssignProNumber, shipmentApprovalRequiredRG, ...payload },
}) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(updateShipmentStatusToRatedEffect, payload);

    let isProNumberGenerated = false;
    let proNumberGeneratedMessage = false;

    if (preAssignProNumber) {
      const { data } = yield call(generateAutomaticProNumber, preAssignProNumber);
      // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
      isProNumberGenerated = data?.success == '1';
      proNumberGeneratedMessage = data?.message
        ? data?.message
        : i18n.t('translation:default.fields.somethingWentWrong');
    }

    const { data: shipmentData } = yield call(getShipmentDetailsEffect, {
      CustomerKey: payload.customerKey,
      ShipmentKey: payload.shipmentKey,
    });

    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentData),
      }),
    );

    yield put(
      shipmentAssignCarrierInSuccess({
        data,
      }),
    );

    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: (
        <Trans
          i18nKey={
            shipmentApprovalRequiredRG
              ? 'translation:default.fields.successfullyAssignedTheTransportationProviderForApprovalProcess'
              : 'translation:default.fields.successfullyAssignedTheTransportationProvider'
          }
        />
      ),
      type: NOTIFICATION_TYPES.SUCCESS,
      ...(shipmentApprovalRequiredRG ? { duration: 8 } : {}),
    });
    if (isProNumberGenerated) {
      yield put(
        setWarningModal({
          description: proNumberGeneratedMessage,
          open: true,
        }),
      );
    }
    if (handleSuccess) {
      handleSuccess();
    }
    yield put(refreshShipmentListInProgress());
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(
      e,
      i18n.t('translation:default.fields.failedToAssignTheTransportationProvider'),
    );
    yield put(
      shipmentAssignCarrierInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* addRateEntry({ payload: { handleSuccess, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(shipmentAddRateEntryEffect, payload);

    const { data: shipmentData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: payload.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentData),
      }),
    );

    yield put(
      addShipmentRateEntryInSuccess({
        data,
      }),
    );

    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyAddedRateEntry'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    if (handleSuccess) {
      handleSuccess();
    }
  } catch (e) {
    console.log(e);
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToAddRateEntry'));
    yield put(
      addShipmentRateEntryInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* validateRateEntry({ payload: { handleSuccess, ...payload } }) {
  try {
    const { data } = yield call(shipmentValidateRateEntryEffect, payload);
    yield put(
      validateShipmentRateEntryInSuccess({
        data,
      }),
    );
    if (handleSuccess) {
      handleSuccess();
    }
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToValidateRateEntry'));
    yield put(
      validateShipmentRateEntryInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* removeRateEntry({ payload: { handleSuccess, ...payload } }) {
  try {
    const { data } = yield call(shipmentRemoveRateEntryEffect, payload);

    const rateShopList = yield select((state) =>
      state.shipment?.rateShopList?.data ? state.shipment?.rateShopList?.data : [],
    );
    yield put(
      getShipmentRateShopListInSuccess({
        // biome-ignore lint/suspicious/noDoubleEquals: TODO: fix
        data: rateShopList?.filter(({ isRateEntry }) => isRateEntry != 1),
        forceUpdate: true,
      }),
    );
    yield put(
      removeShipmentRateEntryInSuccess({
        data,
      }),
    );
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyDeletedRateEntry'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetMasterChilde'));
    yield put(
      removeShipmentRateEntryInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getMasterChildShipmentDetails({ payload }) {
  try {
    const { data } = yield call(getMasterChildShipmentDetailsEffect, payload);
    yield put(
      getMasterChildShipmentDetailsInSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getMasterChildShipmentDetailsInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetMasterChilde')),
      }),
    );
  }
}

function* updateRateEntry({ payload: { handleSuccess, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(shipmentUpdateRateEntryEffect, payload);
    yield put(
      updateShipmentRateEntryInSuccess({
        data,
      }),
    );
    const rateShopList = yield select((state) =>
      state.shipment?.rateShopList?.data ? state.shipment?.rateShopList?.data : [],
    );
    const rateEntryIndex = rateShopList?.findIndex(({ rateShopKey }) => rateShopKey === payload.rateShopKey);
    if (rateEntryIndex >= 0) {
      rateShopList[rateEntryIndex] = {
        ...rateShopList[rateEntryIndex],
        cargoType: payload.cargoType,
        convertedCost: payload.shipmentCost,
        currencyCode: payload.currencyCode,
        trailerKey: payload.trailerKey,
      };
      yield put(
        getShipmentRateShopListInSuccess({
          data: rateShopList,
          forceUpdate: true,
        }),
      );
    }

    if (handleSuccess) {
      handleSuccess();
    }
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullyUpdatedRateEntry'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToUpdateRateEntry'));
    yield put(
      updateShipmentRateEntryInError({
        message: errMessage,
      }),
    );
    yield call(showNotification, {
      message: errMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* convertPartialToShipment() {
  const {
    auth: { user },
    shipment: { shipmentDetails },
  } = yield select((state) => state);
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(convertPartialToShipmentEffect, {
      shipmentKey: shipmentDetails?.data?.shipmentKey,
      userId: user?.data?.id,
    });

    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: shipmentDetails?.data?.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );
    yield put(
      convertPartialToShipmentInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.successfullySavedAsShipment'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSaveAsShipment'));
    yield put(
      convertPartialToShipmentInError({
        message: errorMessage,
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: errorMessage,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getBranchAddress({ payload: { handleSuccess, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getShipmentBranchAddressEffect, payload);
    yield put(
      getShipmentBranchAddressInSuccess({
        data,
      }),
    );

    if (handleSuccess) {
      handleSuccess(data);
    }
    yield put(setAppLoader(false));
  } catch (e) {
    const errMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetBranchAddress'));
    yield put(
      getShipmentBranchAddressInError({
        message: errMessage,
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* getShipmentsStops({ payload }) {
  try {
    const { data } = yield call(getShipmentsStopsEffect, payload);
    yield put(
      getShipmentsStopsInSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentsStopsInError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToGetShipmentsStopsDetails')),
      }),
    );
  }
}

function* getParcelExpressDashboardData(chartType) {
  try {
    const { data } = yield call(getParcelExpressDashboardDataEffect, {
      ResultType: PARCEL_EXPRESS_CHART_TYPES_API[chartType],
    });
    yield put(
      getParcelExpressDashboardDataInSuccess({
        chartType,
        data,
      }),
    );
  } catch (error) {
    yield put(
      getParcelExpressDashboardDataInError({
        chartType,
        message: getErrorMessageFromAPI(error, i18n.t('translation:default.notification.failedToGetData')),
      }),
    );
  }
}

function* forkParcelExpressDashboardData() {
  try {
    yield all([
      call(getParcelExpressDashboardData, PARCEL_EXPRESS_CHART_TYPES.TOTAL_SPEND),
      call(getParcelExpressDashboardData, PARCEL_EXPRESS_CHART_TYPES.TOTAL_SPEND_BY_CARRIERS),
      call(getParcelExpressDashboardData, PARCEL_EXPRESS_CHART_TYPES.BY_MONTHS),
    ]);
  } catch (error) {
    console.log(i18n.t('translation:default.notification.parcelExpressSaga'), error);
  }
}

function* getShipmentTableViewColumns({ payload }) {
  try {
    const { data } = yield call(getShipmentTableViewColumn, payload);
    let columns = DEFAULT_SHIPMENT_TABLE_VIEW_COLUMNS;

    if (data?.length > 0) {
      columns = data.map(({ fieldReferenceName, fieldReferenceValue }) => ({
        columnName: fieldReferenceName,
        columnValue: fieldReferenceValue,
      }));
    }

    columns = columns.map((row) => ({ ...row, id: generateUUIDv4() }));
    yield put(
      getShipmentTableViewColumnsInSuccess({
        data: columns,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentTableViewColumnsInError({
        message: getErrorMessageFromAPI(e, 'Failed to get shipment sorting fields'),
      }),
    );
  }
}

function* saveShipmentTableViewColumns({ payload: { handleDone, ...payload } }) {
  try {
    yield call(saveShipmentTableViewColumn, {
      columnOptions: payload.data.map(({ columnName, columnValue }) => ({
        fieldReferenceName: columnName,
        fieldReferenceValue: columnValue,
      })),
      gridName: 'Shipment',
    });
    yield put(
      getShipmentTableViewColumnsInSuccess({
        data: payload.data,
      }),
    );
    yield put(
      saveShipmentTableViewColumnsInSuccess({
        data: payload.data,
      }),
    );
    if (handleDone) {
      handleDone();
    }
    yield call(showNotification, {
      message: 'Successfully saved shipment columns Options',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    yield put(
      saveShipmentTableViewColumnsInError({
        message: getErrorMessageFromAPI(e, 'Failed to saved shipment columns Options'),
      }),
    );
    yield call(showNotification, {
      message: 'Failed to saved shipment columns Options',
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getShipmentProductListSaga({ payload }) {
  try {
    const { data } = yield call(getShipmentProductListEffect, payload);
    yield put(
      getShipmentProductListInSuccess({
        data: data?.data ? data?.data : [],
        footerSummary: data?.footerSummary,
        totalRecords: data?.totalRecords ? data?.totalRecords : 0,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentProductListInError({
        message: getErrorMessageFromAPI(e, 'Failed to get shipment product list'),
      }),
    );
  }
}

function* getShipmentProductFullListSaga({ payload }) {
  try {
    const { data } = yield call(getShipmentProductFullListEffect, payload);
    yield put(
      getShipmentProductFullListInSuccess({
        data: data ? data : [],
      }),
    );
  } catch (e) {
    yield put(
      getShipmentProductFullListInError({
        message: getErrorMessageFromAPI(e, 'Failed to get shipment product list'),
      }),
    );
  }
}

function* shipmentPartialSaveProducts({
  payload: { notificationTitle, callBack, handleError, shouldRefetch, pageNo, index, ...payload },
}) {
  const {
    shipmentProductList: { PageSize, PageNumber },
    shipmentDetails: {
      data: { shipmentKey },
    },
  } = yield select((state) => state.shipment);
  try {
    const { data } = yield call(shipmentPartialSaveEffect, payload);
    yield put(setShipmentEditStatus(false));
    if (shouldRefetch) {
      const { data } = yield call(getShipmentProductListEffect, {
        PageNumber,
        PageSize: PageSize * pageNo,
        ShipmentKey: shipmentKey,
      });
      yield put(
        getShipmentProductListInSuccess({
          data: data?.data ? data?.data : [],
          footerSummary: data?.footerSummary,
          isSet: true,
          totalRecords: data?.totalRecords ? data?.totalRecords : 0,
        }),
      );
    } else {
      yield put(updateShipmentSingleProductByIndex({ data: payload, index }));
    }
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: `${notificationTitle}.`,
      toastId: '0',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    if (callBack) {
      callBack(data);
    }
    yield put(refreshShipmentDetails({ shipmentKey }));
  } catch (e) {
    if (handleError) {
      handleError(e);
    }
    const errMsg = getErrorMessageFromAPI(e);
    yield call(showNotification, {
      message: errMsg || `${notificationTitle}.`,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
    yield put(
      updateShipmentProductListPartialInError({
        message: errMsg,
      }),
    );
  }
}

function* updateProductFBClass({ payload }) {
  try {
    const { data } = yield call(updateShipmentProductFBCLassEffect, payload);
    yield put(updateShipmentProductFreightClassInSuccess(data));
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: i18n.t('translation:shipment.freightClassSuccessfully'),
      toastId: '0',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    yield put(setAppLoader(false));
    const message = getErrorMessageFromAPI(e, 'Failed to update freight class calculator');
    yield put(
      updateShipmentProductFreightClassInError({
        message,
      }),
    );
    yield call(showNotification, {
      message,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* updateShipmentBOLCarrier({ payload: { handleDone, ...payload } }) {
  try {
    const { data } = yield call(updateShipmentBOLCarrierEffect, payload);
    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: payload.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );
    yield put(updateShipmentBOLCarrierInSuccess(data));
    if (handleDone) {
      handleDone();
    }
  } catch (e) {
    const message = getErrorMessageFromAPI(e, 'Failed to update shipment BOL carrier');
    yield put(
      updateShipmentBOLCarrierInError({
        message,
      }),
    );
    yield call(showNotification, {
      message,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getAdvancedPlanningNoticeEmailsWatcher({ payload }) {
  try {
    const { data } = yield call(getShipmentAdvancePlanningNoticeEmailsEffect, payload);
    yield put(getShipmentAdvancedPlanningNoticeEmailsInSuccess(data));
  } catch (e) {
    const message = getErrorMessageFromAPI(e, 'Failed to get transportation provider list.');
    yield put(
      getShipmentAdvancedPlanningNoticeEmailsInError({
        message,
      }),
    );
  }
}

function* sendAdvancedPlanningNoticeEmailWatcher({ payload: { handleDone, ...payload } }) {
  try {
    const { data } = yield call(sendShipmentAdvancePlanningNoticeEmailEffect, payload);
    const { data: shipmentDetailsData } = yield call(getShipmentDetailsEffect, {
      ShipmentKey: payload.shipmentKey,
    });
    yield put(
      getShipmentDetailsInSuccess({
        data: convertShipmentApiResponseToLocal(shipmentDetailsData),
      }),
    );

    yield put(sendShipmentAdvancedPlanningNoticeEmailInSuccess(data));
    if (handleDone) {
      handleDone();
    }
    yield call(showNotification, {
      message: 'Successfully sent emails to transportation providers.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(refreshShipmentListInProgress());
  } catch (e) {
    const message = getErrorMessageFromAPI(e, 'Failed to send email to transportation providers.');
    yield put(
      sendShipmentAdvancedPlanningNoticeEmailInError({
        message,
      }),
    );
    yield call(showNotification, {
      message,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

// todo refactor it (SPOT QUOTE STATE)

function* getSpotQuoteBidders({ payload }) {
  try {
    const { data } = yield call(getSpotQuoteBiddersEffect, payload);
    yield put(getSpotQuoteBiddersSuccess({ data }));
  } catch (e) {
    yield put(
      getSpotQuoteBiddersError({
        message: getErrorMessageFromAPI(e, 'Failed to get quote bidders'),
      }),
    );
  }
}

function* searchSpotQuoteBidders({ payload }) {
  try {
    const { data } = yield call(searchSpotQuoteBiddersEffect, payload);
    yield put(searchSpotQuoteBiddersSuccess({ data }));
  } catch (e) {
    yield put(
      searchSpotQuoteBiddersError({
        message: getErrorMessageFromAPI(e, 'Failed to search quote bidders'),
      }),
    );
  }
}

function* addSpotQuoteBidders({ payload: { biddingPayload, status } }) {
  try {
    yield call(
      status === QUOTE_STATUSES.openForBid ? addSpotQuoteBiddersEffect : addQuoteBiddersEffect,
      biddingPayload,
    );
    const { data } = yield call(getSpotQuoteBiddersEffect, {
      quoteKey: biddingPayload.quoteKey,
    });
    yield put(getSpotQuoteBiddersSuccess({ data }));
  } catch (e) {
    addSpotQuoteBiddersError({
      message: getErrorMessageFromAPI(e, 'Failed to add quote bidders'),
    });
  }
}

function* deleteSpotQuoteBidders({ payload }) {
  try {
    yield call(deleteSpotQuoteBiddersEffect, payload);
    const { data } = yield call(getSpotQuoteBiddersEffect, {
      quoteKey: payload.quoteKey,
    });
    yield put(getSpotQuoteBiddersSuccess({ data }));
  } catch (e) {
    deleteSpotQuoteBiddersError({
      message: getErrorMessageFromAPI(e, 'Failed to delete quote bidders'),
    });
  }
}

// todo replace this logic to react query
function* getSpotQuoteCollaborators({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getSpotQuoteCollaboratorsEffect, payload);
    yield put(getSpotQuoteCollaboratorsSuccess({ data }));
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      getSpotQuoteCollaboratorsError({
        message: getErrorMessageFromAPI(e, 'Failed to get quote collaborators'),
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* addSpotQuoteCollaborators({ payload }) {
  try {
    yield put(setAppLoader(true));
    yield call(addSpotQuoteCollaboratorsEffect, payload);
    const { data } = yield call(getSpotQuoteCollaboratorsEffect, payload.spotQuoteId);
    yield put(getSpotQuoteCollaboratorsSuccess({ data }));
    yield put(setAppLoader(false));
  } catch (e) {
    addSpotQuoteCollaboratorsError({
      message: getErrorMessageFromAPI(e, 'Failed to add quote collaborators'),
    });
    yield put(setAppLoader(false));
  }
}

function* deleteSpotQuoteCollaborators({ payload }) {
  try {
    yield put(setAppLoader(true));
    yield call(deleteSpotQuoteCollaboratorsEffect, payload);
    const { data } = yield call(getSpotQuoteCollaboratorsEffect, payload.spotQuoteId);
    yield put(getSpotQuoteCollaboratorsSuccess({ data }));
    yield put(setAppLoader(false));
  } catch (e) {
    deleteSpotQuoteCollaboratorsError({
      message: getErrorMessageFromAPI(e, 'Failed to delete quote collaborators'),
    });
    yield put(setAppLoader(false));
  }
}

function* awardBid({ payload }) {
  const { data: shipmentDetails } = yield select((state) => state.shipment.shipmentDetails);

  try {
    yield put(setAppLoader(true));
    yield call(setSpotQuoteStatusAwardedEffect, payload);
    const { data } = yield call(getSpotQuoteBiddersEffect, {
      quoteKey: payload.quoteKey,
    });
    yield put(getSpotQuoteBiddersSuccess({ data }));

    const { data: quoteData } = yield call(getSpotQuote, payload.quoteKey);

    const {
      data: { spotBidsData: searchData },
    } = yield call(getSearchQuoteListEffect, {
      quoteNumber: `${shipmentDetails.quoteNo || shipmentDetails.quoteNo || payload.quoteKey}`,
    });

    if (searchData && searchData.length > 0) {
      yield put(
        setShipmentData({
          ...shipmentDetails,
          awardedTransportationProvider: searchData[0].carrierName,
          status: quoteData.status,
        }),
      );
    }

    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Quote successfully Awarded',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    getSpotQuoteBiddersError({
      message: getErrorMessageFromAPI(e, 'Failed to award bid'),
    });
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to award bid');
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
  }
}

function* deleteShipmentTenderProcessWatcher({ payload }) {
  try {
    yield put(setAppLoader(true));
    yield call(deleteShipmentTenderProcessEffect, payload);
    yield put(refreshShipmentDetails(payload));
    yield put(deleteShipmentTenderProcessInSuccess());
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Successfully deleted shipment rate entry.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(refreshShipmentListInProgress());
  } catch (e) {
    yield put(setAppLoader(false));
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to delete shipment rate entry!');
    yield put(
      deleteShipmentTenderProcessInError({
        message: errorMsg,
      }),
    );
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getCargoSpecificAccessorialsWatcher({ payload }) {
  try {
    const { data } = yield call(getCargoSpecificAccessorialsEffect, payload);
    yield put(
      getCargoSpecificShipmentAccessorialsInSuccess({
        data: orderBy(data, ['isChecked'], ['desc']).map((row) =>
          trimObjectValues({
            ...row,
            codeId: row?.accChargeType,
            isChecked: Boolean(row?.isChecked),
          }),
        ),
      }),
    );
  } catch (e) {
    getCargoSpecificShipmentAccessorialsInError({
      message: getErrorMessageFromAPI(e, 'Failed to delete quote collaborators'),
    });
  }
}

export default function* shipmentSaga() {
  yield takeEvery(ShipmentTypes.GET_SHIPMENT_LIST_PROGRESS, getShipmentList);
  yield takeEvery(ShipmentTypes.GET_SEARCH_QUOTE_LIST_PROGRESS, getSearchQuoteList);
  yield takeEvery(ShipmentTypes.REFRESH_SHIPMENT_LIST_PROGRESS, refreshShipmentList);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_DETAILS_PROGRESS, getShipmentDetails);
  yield takeEvery(ShipmentTypes.GET_SHIPMENT_DASHBOARD_PROGRESS, getShipmentDashboard);
  yield takeEvery(ShipmentTypes.GENERATE_SHIPMENT_NUMBER_PROGRESS, generateShipmentNo);
  yield takeEvery(ShipmentTypes.GENERATE_APPROVAL_NUMBER_PROGRESS, generateApprovalNo);
  yield takeLatest(ShipmentTypes.DELETE_SHIPMENTS_PROGRESS, deleteShipments);
  yield takeLatest(ShipmentTypes.COPY_SHIPMENTS_PROGRESS, copyShipment);
  yield takeLatest(ShipmentTypes.CONSOLIDATE_SHIPMENTS_PROGRESS, consolidateShipments);
  yield takeLatest(ShipmentTypes.CREATE_SHIPMENT_PROGRESS, createShipment);
  yield takeLatest(ShipmentTypes.SHIPMENT_SPOTBID_PROGRESS, shipmentSpotBid);
  yield takeLatest(ShipmentTypes.GET_RATE_SHOP_LIST_PROGRESS, getShipmentRateShopList);
  yield takeLatest(ShipmentTypes.END_SPOT_BID_PROGRESS, shipmentEndSpotBid);
  yield takeLatest(ShipmentTypes.GET_DOCUMENTS_PROGRESS, getShipmentDocumentsList);
  yield takeLatest(ShipmentTypes.GET_DEFAULT_ACCESSORIALS_PROGRESS, getShipmentDefaultAccessorials);
  yield takeLatest(ShipmentTypes.GET_TENDER_EMAIL_PROGRESS, getShipmentTenderEmail);
  yield takeLatest(ShipmentTypes.TENDER_PROCESS_PROGRESS, shipmentTenderProcess);
  yield takeLatest(ShipmentTypes.GET_SPOT_BID_DATA_PROGRESS, getSpotBidData);
  yield takeLatest(ShipmentTypes.SHIPMENT_PARTIAL_SAVE, shipmentPartialSave);
  yield takeLatest(ShipmentTypes.MILEAGE_CALCULATOR_PROGRESS, shipmentMileageCalculator);
  yield takeLatest(ShipmentTypes.GET_CUSTOMER_ROUTINGS_SETTINGS_PROGRESS, getCustomerRoutingsSettings);
  yield takeLatest(ShipmentTypes.SAVE_ADDRESS_BOOK_PROGRESS, saveAddressBook);
  yield takeLatest(ShipmentTypes.DELETE_ADDRESS_BOOK_PROGRESS, deleteAddressBook);
  yield takeLatest(ShipmentTypes.SAVE_PRODUCT_PROGRESS, saveProduct);
  yield takeLatest(ShipmentTypes.GET_TRACKING_DETAILS_PROGRESS, getTrackingDetails);
  yield takeLatest(ShipmentTypes.SEND_DOCUMENT_MAIL_PROGRESS, sendDocumentMail);
  yield takeLatest(ShipmentTypes.SAVE_SHIPMENT_ITRACK_PROGRESS, saveShipmentItrack);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_NOTIFICATION_ROUTING_PROGRESS, getShipmentNotificationRoutingAction);
  yield takeLatest(
    ShipmentTypes.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_PROGRESS,
    getShipmentNotificationDistributorsAction,
  );
  yield takeLatest(ShipmentTypes.SAVE_NOTIFICATION_DISTRIBUTORS_PROGRESS, saveNotificationDistributorsAction);
  yield takeLatest(ShipmentTypes.DELETE_NOTIFICATION_DISTRIBUTORS_PROGRESS, deleteNotificationDistributorsAction);
  yield takeLatest(ShipmentTypes.SAVE_NOTIFICATION_ROUTING_PROGRESS, saveNotificationRouting);
  yield takeLatest(ShipmentTypes.DELETE_NOTIFICATION_ROUTING_PROGRESS, deleteNotificationRouting);
  yield takeEvery(ShipmentTypes.SEARCH_CUSTOMER_ADDRESS_BOOK_PROGRESS, getShipmentCustomerAddressSearch);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_PROGRESS, getShipmentCustomerAccessorials);
  yield takeLatest(ShipmentTypes.CREATE_SHIPMENT_QUOTE_PROGRESS, createShipmentQuote);
  yield takeLatest(ShipmentTypes.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_PROGRESS, saveShipmentAccountingPartial);
  yield takeLatest(ShipmentTypes.CREATE_SHIPMENT_FROM_QUOTE_PROGRESS, createShipmentFromQuote);
  yield takeLatest(ShipmentTypes.GET_MILAGE_BY_STOPS_PROGRESS, getMilageByStops);
  yield takeLatest(ShipmentTypes.GET_PARCEL_EXPRESS_RATES_PROGRESS, getParcelExpressRates);
  yield takeLatest(ShipmentTypes.CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_PROGRESS, createParcelExpressShipment);
  yield takeLatest(ShipmentTypes.VALIDATE_AND_GET_APPROVERS_LIST_PROGRESS, validateAndGetApprovers);
  yield takeLatest(ShipmentTypes.SHIPMENT_ADD_BIDDER_PROGRESS, shipmentAddBidder);
  yield takeLatest(ShipmentTypes.CREATE_CHILD_SHIPMENT_PROGRESS, createChildShipment);
  yield takeLatest(ShipmentTypes.SEND_APPROVAL_REQUEST_PROGRESS, sendApprovalRequest);
  yield takeLatest(ShipmentTypes.ASSIGN_CARRIER_PROGRESS, assignCarrierToShipment);
  yield takeLatest(ShipmentTypes.ADD_RATE_ENTRY_PROGRESS, addRateEntry);
  yield takeLatest(ShipmentTypes.VALIDATE_RATE_ENTRY_PROGRESS, validateRateEntry);
  yield takeLatest(ShipmentTypes.REMOVE_RATE_ENTRY_PROGRESS, removeRateEntry);
  yield takeLatest(ShipmentTypes.GET_MASTER_CHILD_SHIPMENT_DETAILS_PROGRESS, getMasterChildShipmentDetails);
  yield takeLatest(ShipmentTypes.UPDATE_RATE_ENTRY_PROGRESS, updateRateEntry);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_BRANCH_ADDRESS_PROGRESS, getBranchAddress);
  yield takeLatest(ShipmentTypes.CONVERT_PARTIAL_TO_SHIPMENT_PROGRESS, convertPartialToShipment);
  yield takeLatest(ShipmentTypes.GET_SHIPMENTS_STOPS_PROGRESS, getShipmentsStops);
  yield takeLatest(ShipmentTypes.GET_PARCEL_EXPRESS_DASHBOARD_DATA_PROGRESS, forkParcelExpressDashboardData);
  yield takeLatest(ShipmentTypes.GET_TABLE_VIEW_COLUMNS_PROGRESS, getShipmentTableViewColumns);
  yield takeLatest(ShipmentTypes.SAVE_TABLE_VIEW_COLUMNS_PROGRESS, saveShipmentTableViewColumns);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_PRODUCT_LIST_PROGRESS, getShipmentProductListSaga);
  yield takeLatest(ShipmentTypes.GET_SHIPMENT_PRODUCT_FULL_LIST_PROGRESS, getShipmentProductFullListSaga);
  yield takeLatest(ShipmentTypes.UPDATE_PRODUCT_LIST_PARTIAL_PROGRESS, shipmentPartialSaveProducts);
  yield takeLatest(ShipmentTypes.UPDATE_FREIGHT_CLASS_PROGRESS, updateProductFBClass);
  yield takeLatest(ShipmentTypes.UPDATE_BOL_CARRIER_PROGRESS, updateShipmentBOLCarrier);
  yield takeLatest(ShipmentTypes.GET_ADVANCED_PLANNING_EMAILS_PROGRESS, getAdvancedPlanningNoticeEmailsWatcher);
  yield takeLatest(ShipmentTypes.SEND_ADVANCED_PLANNING_EMAIL_PROGRESS, sendAdvancedPlanningNoticeEmailWatcher);
  yield takeLatest(ShipmentTypes.REFRESH_SHIPMENT_DETAILS, getShipmentDetails);
  yield takeLatest(ShipmentTypes.GET_SPOT_QUOTE_BIDDERS_PROGRESS, getSpotQuoteBidders);
  yield takeLatest(ShipmentTypes.SEARCH_SPOT_QUOTE_BIDDERS_PROGRESS, searchSpotQuoteBidders);
  yield takeLatest(ShipmentTypes.ADD_SPOT_QUOTE_BIDDERS_PROGRESS, addSpotQuoteBidders);
  yield takeLatest(ShipmentTypes.DELETE_SPOT_QUOTE_BIDDERS_PROGRESS, deleteSpotQuoteBidders);
  yield takeLatest(ShipmentTypes.AWARD_SPOT_QUOTE_BIDDERS_PROGRESS, saveShipmentDetails);
  yield takeLatest(ShipmentTypes.AWARD_BID, awardBid);
  yield takeLatest(ShipmentTypes.DELETE_SHIPMENT_TENDER_PROGRESS, deleteShipmentTenderProcessWatcher);
  yield takeLatest(ShipmentTypes.ADD_SPOT_QUOTE_COLLABORATORS_PROGRESS, addSpotQuoteCollaborators);
  yield takeLatest(ShipmentTypes.GET_SPOT_QUOTE_COLLABORATORS_PROGRESS, getSpotQuoteCollaborators);
  yield takeLatest(ShipmentTypes.DELETE_SPOT_QUOTE_COLLABORATORS_PROGRESS, deleteSpotQuoteCollaborators);
  yield takeLatest(ShipmentTypes.GET_CARGO_SPECIFIC_ACCESSORIALS_PROGRESS, getCargoSpecificAccessorialsWatcher);
}
